<div
  class="code-hunks-toggle ab-checkbox"
  *ngIf="codeHunksEnabled && hasCodeHunks"
>
  <input
    id="code-hunks-toggle"
    type="checkbox"
    [(ngModel)]="showCodeHunks"
    (ngModelChange)="toggleCodeHunks()"
  />
  <label class="ab-checkbox__label" for="code-hunks-toggle"
    >Show code hunks</label
  >
</div>
<div class="alert alert-warning alert--small" *ngIf="hasMinFiles">
  We see you are using minified files. Integrate your source maps with Airbrake
  to decode your backtrace.
  <a
    class="alert-link external-link"
    href="https://docs.airbrake.io/docs/features/private-sourcemaps/"
    target="_blank"
  >
    Learn More
  </a>
</div>
<div class="backtrace-container" *ngFor="let error of errors; index as errorIndex; trackBy: errorTrackBy">
  <span *ngIf="errorIndex > 0"
    >Caused by
    <strong class="ab-type" *ngIf="error.type">{{ error.type }}: </strong
    ><span class="ab-error-message">{{
      error | errorMessageWithoutType
    }}</span></span
  >
  <div
    class="backtrace"
    *ngFor="
      let frame of error.backtrace;
      index as frameIndex;
      trackBy: frameTrackBy
    "
  >
    <ab-file-line
      [file]="frame.file"
      [line]="frame.line"
      [column]="frame.column"
      [repoUrl]="repoUrl"
      [gitRevision]="gitRevision"
      [rootDir]="rootDir"
    ></ab-file-line
    ><span *ngIf="frame.function"
      ><span class="file-line__function-sep"> in </span
      ><span class="file-line__function-name">{{ frame.function }}</span></span
    >
    <div class="code-hunk code-hunk--real" *ngIf="showCodeHunks && frame.code">
      <div
        class="code-hunk__line"
        *ngFor="
          let codeFrame of frame.code | keyvalue: orderBy;
          trackBy: trackByIndex
        "
      >
        <div class="code-hunk__td">
          <pre
            class="code-hunk__pre"
            [ngClass]="{
              'code-hunk__pre--highlight': frame.line === codeFrame.key
            }"
            >{{ codeFrame.key }}:</pre
          >
        </div>
        <div class="code-hunk__td">
          <pre
            class="code-hunk__pre"
            [ngClass]="{
              'code-hunk__pre--highlight': frame.line === codeFrame.key
            }"
            >{{ codeFrame.value }}</pre
          >
        </div>
      </div>
    </div>
    <div
      class="code-hunk code-hunk--sample"
      *ngIf="
        errorIndex === 0 && frameIndex === 0 && !codeHunksEnabled && frame.code
      "
    >
      <div class="alert alert-info alert--small mt-2">
        This is a sample code hunk. Code hunks are lines of code surrounding
        each backtrace frame.
      </div>
      <div class="code-hunk__line code-hunk__line--sample">
        <div class="code-hunk__td">
          <pre class="code-hunk__pre">159:</pre>
        </div>
        <div class="code-hunk__td">
          <pre class="code-hunk__pre">
func (b *Buffer) Grow(n int) {{ "{" }}</pre
          >
        </div>
      </div>
      <div class="code-hunk__line code-hunk__line--sample">
        <div class="code-hunk__td">
          <pre class="code-hunk__pre">160:</pre>
        </div>
        <div class="code-hunk__td">
          <pre class="code-hunk__pre">	if n < 0 {{ "{" }}</pre>
        </div>
      </div>
      <div class="code-hunk__line code-hunk__line--sample">
        <div class="code-hunk__td">
          <pre class="code-hunk__pre">161:</pre>
        </div>
        <div class="code-hunk__td">
          <pre class="code-hunk__pre code-hunk__pre--highlight">
		panic("bytes.Buffer.Grow: negative count")</pre
          >
        </div>
      </div>
      <div class="code-hunk__line code-hunk__line--sample">
        <div class="code-hunk__td">
          <pre class="code-hunk__pre">162:</pre>
        </div>
        <div class="code-hunk__td">
          <pre class="code-hunk__pre">	{{ "{" }}</pre>
        </div>
      </div>
      <div class="code-hunk__line code-hunk__line--sample">
        <div class="code-hunk__td">
          <pre class="code-hunk__pre">163:</pre>
        </div>
        <div class="code-hunk__td">
          <pre class="code-hunk__pre">	m := b.grow(n)</pre>
        </div>
      </div>
      <button
        class="btn btn--upgrade code-hunk__upgrade-button"
        (click)="openUpgradeModal($event)"
        data-feature="code_hunks"
        type="button"
      >
        Enable Code Hunks
      </button>
    </div>
  </div>
</div>
